export default {
  type: {
    event: 'Event',
    coach: 'Training',
    tournament: 'Tournament'
  }
}